// extracted by mini-css-extract-plugin
module.exports = {"sectionHeading":"UnfinishedMovieList_sectionHeading__gBUXX","icon":"UnfinishedMovieList_icon__YsVSe"};